'use client';

import { Container } from '@/new/components';
import style from './Experts.module.scss';
import { useEffect, useRef, useState } from 'react';
import { TitleSection } from '@/new/ui/TitleSection/TitleSection';
import { EXPERT, IContacts, IExpert } from '@/app/(page)/(home)/constats';
import styles from '@/app/(page)/(home)/modules/BuyWithUs/BuyWithUs.module.scss';

export const Experts = () => {
  const slideContainerRef = useRef<HTMLDivElement>(null);
  const [visibleWidth, setVisibleWidth] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const amount = EXPERT.length;

  useEffect(() => {
    const updateWidth = () => {
      if (slideContainerRef.current) {
        setVisibleWidth(slideContainerRef.current.clientWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const goRight = () => {
    setCurrentIndex(prev => (prev < amount - 1 ? prev + 1 : 0));
  };

  const goLeft = () => {
    setCurrentIndex(prev => (prev > 0 ? prev - 1 : amount - 1));
  };

  return (
    <Container>
      <h2 className={`${styles.title} ${styles['fade-in-up']}`}>Наши эксперты</h2>

      <div className={style.slider}>
        <div className={style.arrow_cont}>
          <div onClick={goLeft} className={style.arrow}></div>
        </div>
        <div className={style.slider_container} ref={slideContainerRef}>
          <div
            className={style.slide}
            style={{
              transform: `translateX(-${currentIndex * visibleWidth}px)`,
              width: `${amount * 100}%`,
            }}
          >
            {EXPERT.map((exp: IExpert, index) => (
              <div
                key={index + '_expert'}
                className={style.Experts}
                style={{ width: `${100 / amount}%` }}
              >
                <div
                  className={style.circle}
                  style={{
                    background: `url(${exp.img}) center/cover no-repeat`,
                  }}
                ></div>
                <div className={style.info}>
                  <div className={style.expertInfo}>
                    <div
                      className={style.smallcircle}
                      style={{
                        background: `url(${exp.img}) center/cover no-repeat`,
                      }}
                    ></div>
                    <div className={style.specalist}>
                      <h3>{exp.name}</h3>
                      <p>{exp.spec}</p>
                    </div>
                  </div>
                  {!!exp.contacts?.length && (
                    <div className={style.callback_cont}>
                      {exp.contacts.map((cont: IContacts, idx) => (
                        <div key={idx} className={style.callback}>
                          <div className={style.callback__title}>{cont.title}</div>
                          <div className={style.callback__data}>{cont.data}</div>
                        </div>
                      ))}
                    </div>
                  )}
                  {!!exp.text && <p>{exp.text}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={style.arrow_cont}>
          <div
            style={{ transform: 'rotate(180deg)' }}
            onClick={goRight}
            className={style.arrow}
          ></div>
        </div>
      </div>
    </Container>
  );
};
